var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rdStatus',{attrs:{"type":_vm.statusConfig.type}},[_vm._v("\n\t\t"+_vm._s(_vm.statusConfig.label)+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }